<script>
import DateLabel from '@/js/components/common/labels/DateLabel';

export default {
    name: 'CreatedAtLabel',

    functional: true,

    props: {
        date: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        if (!props.date || props.date.length === 0) {
            return null;
        }

        data.props = {
            date: props.date,
            prefix: parent.$t('common.labels.created-at.prefix'),
        };

        return createElement(DateLabel, data);
    },
};
</script>
